import styles from './style.module.scss';

interface Props {
    total: number;
    limit: number;
    page: number;
    setPage: (page: number) => void;
};

const Pagination = ({ total, limit, page, setPage }: Props) => {
    const pages = Math.ceil(total / limit);
    const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1);

    return (
        <div className={styles.pagination}>
            <button
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                className={`${styles.pageNumber} ${page === 1 ? styles.disabled : ''}`}
            >
                <span>&#10094;</span>
            </button>
            {pageNumbers.map(pageNumber => (
                <button
                    key={pageNumber}
                    onClick={() => setPage(pageNumber)}
                    className={`${styles.pageNumber} ${pageNumber === page ? styles.active : ''}`}
                >
                    <span>{pageNumber}</span>
                </button>
            ))}
            <button
                onClick={() => setPage(page + 1)}
                disabled={page === pages}
                className={`${styles.pageNumber} ${page === pages ? styles.disabled : ''}`}
            >
                <span>&#10095;</span>
            </button>
        </div>
    )
}

export default Pagination;